"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var actions_1 = require("../actions/Modal/actions");

var types_1 = require("../actions/Modal/types");

var MessageTransport_1 = require("../MessageTransport");
/**
 * If we’re in a modal context and size is `Auto`, set up modal auto sizing.
 * @param app App Bridge client application instance
 *
 * @internal
 */


function setupModalAutoSizing(app) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2
      /*return*/
      , app.getState().then(function (appState) {
        var context = appState.context;

        if (context !== MessageTransport_1.Context.Modal) {
          return;
        }

        var _a = appState.modal,
            id = _a.id,
            size = _a.size;

        if (size === types_1.Size.Auto) {
          createMutationObserver(app, id);
        }
      })];
    });
  });
}

exports.setupModalAutoSizing = setupModalAutoSizing;
/**
 * Sets up modal auto sizing, using a MutationObserver.
 *
 * @param app App Bridge client application instance
 * @param id Currently active modal instance ID
 *
 * @internal
 */

function createMutationObserver(app, id) {
  var lastKnownWindowHeight = -1;
  var mutationTimeoutId;
  var mutationObserverConfig = {
    attributes: true,
    attributeOldValue: false,
    characterData: true,
    characterDataOldValue: false,
    childList: true,
    subtree: true
  };
  var mutationObserver = new MutationObserver(debouncedResizeHandler);
  mutationObserver.observe(document.body, mutationObserverConfig);
  updateHeight();

  function debouncedResizeHandler() {
    if (mutationTimeoutId) {
      window.clearTimeout(mutationTimeoutId);
    }

    mutationTimeoutId = window.setTimeout(updateHeight, 16);
  }

  function updateHeight() {
    var height = document.body.scrollHeight;

    if (height !== lastKnownWindowHeight) {
      lastKnownWindowHeight = height;
      app.dispatch(actions_1.updateModalSize({
        id: id,
        height: String(height)
      }));
    }
  }
}

exports.createMutationObserver = createMutationObserver;